import React from "react";
import { MimaText, Modal } from "../../components";
import moment from "moment";

const ViewMorePaymentMethod = ({ closeModal, selectedItem }) => {
  return (
    <Modal closeModal={closeModal}>
      <div>
        <MimaText variant="subtitleBold" align="center" mb={3}>
          Payment Method Info
        </MimaText>

        <MimaText labelTitle="Created date" mb={1}>
          {moment(selectedItem.createdAt).format("DD/MM/YYYY")}
        </MimaText>
        <MimaText labelTitle="Country code" mb={1}>
          {selectedItem.countryCode}
        </MimaText>
        <MimaText labelTitle="currency code" mb={1}>
          {selectedItem.currencyCode}
        </MimaText>

        <MimaText mt={1} variant="bodyBold" align="center">
          Mode Of Payment
        </MimaText>

        {selectedItem.methods.map((item) => {
          return (
            <div key={item._id}>
              <MimaText labelTitle="name" variant="body" mt={2}>
                {item.name}
              </MimaText>
              <MimaText variant="small" mt={1}>
                Required Fields{" "}
              </MimaText>
              {item.requiredFields.map((x) => (
                <>
                  <MimaText variant="small">{x}</MimaText>
                </>
              ))}
            </div>
          );
        })}
      </div>
    </Modal>
  );
};
export default ViewMorePaymentMethod;
